module.exports = __webpack_public_path__ + "phone-answer-after-hours.mp3";


//////////////////
// WEBPACK FOOTER
// ./app/assets/audio/phone-answer-after-hours.mp3
// module id = 975
// module chunks = 0